<template>
  <div class="vector">
    <div class="buttons has-addons">
      <span
        @click="applyClass(vector.class_id)"
        class="is-small vector_type_name"
      >
        <i class="fa fa-circle" :style="{ color: vector.color }"></i>
      </span>
      <span
        @click="toggleVectors(vector.class_id)"
        class="class_name is-small is-capitalized is-rounded is-regular-16-000-42"
        :class="{ active: isActive }"
        v-tooltip="vector.description"
      >
        {{ vector.description || "NA" }}
        <span
          class="tag"
          v-if="vector.num_shortcut>=0 || shortcut_map[vector.class_id]>=0"
        >
          {{ vector.num_shortcut>=0?vector.num_shortcut: shortcut_map[vector.class_id] }}
        </span>
      </span>
      <span class="is-small class_count">{{ vector.count }}</span>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      isActive: true,
      shortcut_map: {
        100: 0,
        101: 1,
        102: 2,
        103: 3,
        104: 4,
        105: 5,
        106: 6,
        107: 7,
        108: 8,
        109: 9,
      },
    };
  },
  props: ["vector", "is_group_active"],
  computed: {
    ...mapGetters(["draw", "features", "active_layer", "vectors"]),
    shortcuts() {
      let arr = [];
      Object.values(this.vectors).forEach((v) => {
        arr[v.num_shortcut] = [v.class_id, v.class_name];
      });
      return arr;
    },
  },
  methods: {
    toggleVectors(class_id) {
      if (this.isActive) {
        this.$store.dispatch("remove_layer_features", class_id);
      } else {
        this.$store.dispatch("add_layer_features", class_id);
      }
      this.isActive = !this.isActive;
    },
    applyClass(num) {
      // if (this.shortcuts[num]) {
      for (let id of this.draw.getSelectedIds()) {
        this.draw.setFeatureProperty(id, "class_id", num);
        this.draw.setFeatureProperty(
          id,
          "class_name",
          this.vectors[num].class_name
        );
      }
      // }
      this.$store.dispatch("update_vector_count");
    },
  },
  watch: {
    active_layer: function (val) {
      this.isActive = true;
    },
    is_group_active: function (val) {
      this.toggleVectors(this.vector.class_id);
    },
  },
};
</script>
<style lang="scss" scoped>
@keyframes slide-left {
  from {
    margin-left: 100%;
    width: 300%;
  }

  to {
    margin-left: 0%;
    width: 100%;
  }
}

.vector {
  display: flex;
  margin-bottom: 0.6rem;
  font-size: 14px;
  font-family: Barlow;
  color: #171e48;
  .class_name {
    cursor: pointer;
    text-align: left;
    margin-left: 1rem;
    font-weight: 400;
    text-transform: capitalize;
    text-decoration: line-through;
    position: relative;
    justify-content: left;
    width: 175px;
    overflow: hidden;
    z-index: 1;
    @media (max-width: 900px) {
      width: 100px;
    }
    i {
      visibility: visible;
      position: absolute;
      z-index: 1;
      right: 3px;
    }
    .fa-edit-btn {
      right: 1rem;
    }
    &.active {
      text-decoration: none;
    }
  }
  .active-feature-type {
    background: #343434;
    color: #fff;
  }
  .class_count {
    width: 50px;
    font-family: Barlow-medium;
    font-size: 16px;
    color: #171e48;
  }
}
</style>

